import { Calendar } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { PRESETS } from "../lib/periodos";

const AGRUPAR = [["dia", "Dia"], ["semana", "Semana"], ["mes", "Mês"]];

/** Período (atalhos + datas) e agrupamento, numa linha acima do gráfico. */
export default function FiltroFluxo({ f }) {
  const { preset, escolherPreset, periodo, definir } = f;
  return (
    <div className="rounded-2xl border bg-card p-3 sm:p-4 flex flex-wrap items-center gap-2" data-e2e="filtro-fluxo">
      <Calendar className="w-4 h-4 text-muted-foreground mr-1" />
      {PRESETS.filter((p) => p.key !== "custom").map((p) => (
        <Button key={p.key} size="sm" variant={preset === p.key ? "default" : "outline"} onClick={() => escolherPreset(p.key)}>{p.label}</Button>
      ))}
      {/* Celular: as duas datas dividem a linha (o ícone do calendário saía do campo) */}
      <div className="flex items-center gap-1 sm:gap-1.5 w-full sm:w-auto">
        <Input type="date" value={periodo.inicio} onChange={(e) => definir("inicio", e.target.value)} className="h-9 flex-1 min-w-0 pl-2 pr-1 sm:px-3 sm:flex-none sm:w-[150px]" aria-label="Data inicial" />
        <span className="text-muted-foreground text-sm">até</span>
        <Input type="date" value={periodo.fim} onChange={(e) => definir("fim", e.target.value)} className="h-9 flex-1 min-w-0 pl-2 pr-1 sm:px-3 sm:flex-none sm:w-[150px]" aria-label="Data final" />
      </div>
      <div className="inline-flex rounded-lg border bg-muted/40 p-0.5 ml-auto">
        {AGRUPAR.map(([v, t]) => (
          <button key={v} type="button" onClick={() => definir("agrupar", v)}
            className={`px-3 h-8 rounded-md text-xs font-medium transition-colors ${periodo.agrupar === v ? "bg-background shadow-sm text-foreground" : "text-muted-foreground hover:text-foreground"}`}>
            Por {t.toLowerCase()}
          </button>
        ))}
      </div>
    </div>
  );
}
